/*
 * File: addressesFiltersSlice.ts
 * Project: rosita
 * -----
 * Last Modified: 25 Feb 2022 1:16:44 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetProductsParams } from 'models/Product';

const initialState: GetProductsParams = {
  offset: 0,
  manufacturerNameContains: undefined,
  categoryNameContains: undefined,
  productNameContains: undefined,
  productDescriptionContains: undefined,
  productNumberContains: undefined,
  alternateItemIdContains: undefined,
  isKit: undefined,
  isItemConfigurable: undefined,
  hasSubstitutions: undefined,
  isCommonStock: undefined,
  deploymentTypeEquals: undefined
};

export const juliaProductsParams = createSlice({
  name: 'juliaProductsParams',
  initialState,
  reducers: {
    setOffset: (state, { payload }: PayloadAction<GetProductsParams['offset']>) => {
      state.offset = payload;
    },
    incrementOffset: (state) => {
      state.offset += 25;
    },
    setManufacturerNameContains: (state, { payload }: PayloadAction<GetProductsParams['manufacturerNameContains']>) => {
      state.manufacturerNameContains = payload;
      state.offset = 0;
    },
    setCategoryNameContains: (state, { payload }: PayloadAction<GetProductsParams['categoryNameContains']>) => {
      state.categoryNameContains = payload;
      state.offset = 0;
    },
    setProductNameContains: (state, { payload }: PayloadAction<GetProductsParams['productNameContains']>) => {
      state.productNameContains = payload;
      state.offset = 0;
    },
    setProductDescriptionContains: (state, { payload }: PayloadAction<GetProductsParams['productDescriptionContains']>) => {
      state.productDescriptionContains = payload;
      state.offset = 0;
    },
    setProductNumberContains: (state, { payload }: PayloadAction<GetProductsParams['productNumberContains']>) => {
      state.productNumberContains = payload;
      state.offset = 0;
    },
    setAlternateItemIdContains: (state, { payload }: PayloadAction<GetProductsParams['alternateItemIdContains']>) => {
      state.alternateItemIdContains = payload;
      state.offset = 0;
    },
    setIsKit: (state, { payload }: PayloadAction<GetProductsParams['isKit']>) => {
      state.isKit = payload;
      state.offset = 0;
    },
    setIsItemConfigurable: (state, { payload }: PayloadAction<GetProductsParams['isItemConfigurable']>) => {
      state.isItemConfigurable = payload;
      state.offset = 0;
    },
    setHasSubstitutions: (state, { payload }: PayloadAction<GetProductsParams['hasSubstitutions']>) => {
      state.hasSubstitutions = payload;
      state.offset = 0;
    },
    setIsCommonStock: (state, { payload }: PayloadAction<GetProductsParams['isCommonStock']>) => {
      state.isCommonStock = payload;
      state.offset = 0;
    },
    setDeploymentTypeEquals: (state, { payload }: PayloadAction<GetProductsParams['deploymentTypeEquals']>) => {
      state.deploymentTypeEquals = payload;
      state.offset = 0;
    }
  }
});

export const {
  setOffset,
  incrementOffset,
  setAlternateItemIdContains,
  setCategoryNameContains,
  setHasSubstitutions,
  setIsItemConfigurable,
  setProductDescriptionContains,
  setIsKit,
  setManufacturerNameContains,
  setProductNameContains,
  setProductNumberContains,
  setIsCommonStock,
  setDeploymentTypeEquals
} = juliaProductsParams.actions;
